import {useQuery, gql} from "@apollo/client";
var  RANDOM_HV_PRODUCTS = gql`
query RandomHVProducts {
  randomProductsSQL {
    contentItemId
    displayText
    productAdvantageList {
      contentItems {
        ... on ProductAdvantage {
          createdUtc
          displayText
          htmlBody {
            html
          }
          productId {
            contentItems {
              ... on Product {
                alias {
                  alias
                }
              }
            }
          }
        }
      }
    }
    productPickedComplementaryInfoList {
      contentItems {
        ... on ProductComplementaryInfo {
          complementaryInfoValue
          displayText
          complementaryInfo {
            contentItems {
              ... on ComplementaryInfo {
                id
                displayText
                userTitle
                parentComplementaryInfo {
                  contentItems {
                    ... on ComplementaryInfo {
                      id
                      displayText
                      contentItemId
                    }
                  }
                }
              }
            }
          }
          createdUtc
        }
      }
    }
    productImageList {
      contentItems {
        ... on ProductImage {
          displayText
          productImage {
            urls(first: 1)
          }
        }
      }
    }
    alias {
      alias
    }
  }
}
  `;
  export const useRandomSelectedHVProducts = (searchText) => {
    const {error, loading, data} = useQuery(RANDOM_HV_PRODUCTS,{
      variables: { searchText: searchText }
    });
    
    return {
      error, data, loading
    };
    } 
  